export const validateWhitespace = (value: string): boolean => {
  const controlValue = value && value.toString().trim();

  if (!controlValue) {
    return true;
  }

  return (controlValue.length === 0);
};
